import { useDisclosure, useMediaQuery, useDebouncedValue } from "@mantine/hooks";
import _ from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { createB2BAPI } from "../../../api/Interceptor";
import notify from "../../../utils/Notification";
import SideBarLaptop from "../sidebar/SideBarLaptop";
import SideBarMobile from "../sidebar/SideBarMobile";
import './AppBody.css';

export default function AppBody() {
  const sideBarRef = useRef(null);
  const mainBodyRef = useRef(null);
  const navigate = useNavigate();
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [filterHeader, setFilterHeader] = useState('');
  const [selectedMenu, setSelectedMenu] = useState({});
  const [filterValues, setFilterValues] = useState([]);
  const [overAllMenu, setOverAllMenu] = useState(null);
  const [menuOpened, setMenuOpened] = useState(false);
  const [overAllFilter, setOverAllFilters] = useState([]);
  const [sideBarFolded, setSideBarFolded] = useState(true);
  const [opened, { open, close }] = useDisclosure(false);
  const isTab = useMediaQuery('(min-width: 768px) and (max-width: 991px)');
  const isMobile = useMediaQuery('(max-width: 767px)');
  const innerwidth = useMemo(() => window.innerWidth, [])
  const [products, setProducts] = useState([]);
  const [fromCollection, setFromCollection] = useState(false);
  const isSample = localStorage.getItem("token") ? false : true;
  const [hasMore, setHasMore] = useState(true);
  const [itemCount, setItemCount] = useState(0)
  const [filterParameters, setFilterParameters] = useState({})
  const [render, setRender] = useState(false)
  const [reload, setReload] = useState()
  const toggleMenu = () => setMenuOpened((prev) => !prev);
  const location = useLocation();
  const [groupDisplayOrder, setGroupDisplayOrder] = useState({})
  const [sortValue, setSortValue] = useState('New false');
  const [allFilter, setAllFilter] = useState([])
  const [profile, setProfile] = useState({})
  const [search, setSearch] = useState('')
  const [debouncedSearch] = useDebouncedValue(search, 500)
  const [collectionId, setCollectionId] = useState(location?.state?.collectionId || '');
  const [collectid, setCollectId] = useState(location?.state?.collectionId || '');
  const [collectionName, setCollectionName] = useState(location?.state?.fullCollection?.collectionName || '');
  const [loadColour, setloadColour] = useState(false);
  const [allCollection, setAllCollection] = useState({});
  useEffect(() => {
    function handleClickOutside(event) {
      if (mainBodyRef.current?.contains(event.target)) {
        setSideBarFolded(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const { vendorId, pims, pagee } = location.state?.vendorFilter || {};
  const [page, setPage] = useState(0);
  const [vendorIddApp, setVendorIddApp] = useState(vendorId || null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuOpened &&
        sideBarRef.current &&
        !sideBarRef.current.contains(event.target)
      ) {
        setMenuOpened(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpened]);

  useEffect(() => {
    setProducts([])
    setHasMore(true);
    setRender(false)
    const value = location.state?.value
    if (value) {
      if (location.state.page !== 0) {
        setSelectedItems(value)
      }
    }
  }, [location.state?.value])

  useEffect(() => {
    setProducts([])
    setHasMore(true);
    setRender(false);
    setPage(0)
    setReload(prev => !prev)
  }, [vendorIddApp])

  useEffect(() => {
    if (selectedItems) {
      const convertedList = Object.entries(selectedItems || {}).flatMap(([category, items]) =>
        (items || [])?.map(item => ({ ...item, category }))
      );
      setRender(false)
      setOverAllFilters(convertedList);
    }
    searchByFilter();
  }, [selectedItems, location.state?.value]);

  useEffect(() => {
    if (page > 0) {
      fetchProducts();
    }
    if (location.state?.page == 0) {
      setPage(location.state.page)
      overAllFilterClearAll()
      setVendorIddApp(null);
      fetchProducts()
    }
  }, [page, location.state]);

  useEffect(() => {
    // setProducts([])
    // setHasMore(true);
    // setRender(false)
    // setPage(0)
    if (location?.state?.value) {
      if (Object.values(filterParameters).length > 0) {
        fetchProducts();
        setVendorIddApp(null);
      }
    } else {
      fetchProducts();
    }

  }, [reload]);

  useEffect(() => {
    setProducts([])
    setHasMore(true);
    setPage(0)
    setRender(false)
    setReload(prev => !prev)
  }, [filterParameters, sortValue, debouncedSearch])

  const searchByFilter = () => {
    const keys = Object.keys(selectedItems)
    const m = {}
    _.map(keys, k => {
      if (k.includes('MOQ')) {
        const values = selectedItems[k];

        m[k] = [
          ...values.map(item => item.moq || "0")
        ];
      }
      else if (k.includes("Weight") || k.includes("Width") || k.includes("Price")) {
        const values = selectedItems[k];
        if (values.length > 0) {
          m[k] = values?.map(item => item.min || "0");
        }
        const maxValues = values.map(item => item.max).filter(max => max !== "" && max !== undefined);


        if (maxValues.length > 0) {
          m[k] = m[k].concat(maxValues);
        }
      } else if (k.includes("Fabric Content")) {
        const values = selectedItems[k];
        m[k] = [
          ...values?.map(item => item.value)
        ];
      } else {
        m[k] = _.map(selectedItems[k], item => item.variantId ? item.id : item.categoryId)
      }
    })
    setFilterParameters(m)
  }
  const fetchProducts = async (fromsearch = false) => {
    if ((!hasMore || loading) && !fromsearch) return;
    setLoading(true);
    try {
      let url = '';
      if (localStorage.getItem('token')) {
        url = `pim/searchFilter?page=${fromsearch ? 0 : page}&size=${innerwidth >= 1440 ? 14 : 12
          }&sortData=${sortValue}&search=${debouncedSearch}&collectionId=${collectionId}`;
        if (vendorIddApp) {
          url += `&vendorId=${vendorIddApp}`;
        }
        url += `&view=true`;
      } else {
        url = `pim/sampleProduct`;
      }
      const payload = filterParameters && Object.keys(filterParameters).length > 0
        ? filterParameters
        : { undefined: [] };
      const response = await B2B_API.post(url, { json: payload }).json();
      if (!response || !response.response) {
        throw new Error('Invalid response structure');
      }
      const pim = response.response.content || [];
      const filteredPim = pim.map(p => ({
        ...p,
        pimVariants: p.pimVariants.filter(pv => pv.status === 'ACTIVE')
      }));
      const totalPages = response.response.totalPages;
      setItemCount(response.response.totalElements);
      if (render) {
        setProducts(prev => [...prev, ...filteredPim]);
      } else {
        setProducts(filteredPim);
        setRender(true);
      }
      setHasMore(isSample ? false : page < totalPages - 1);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
      setLoading(false);
    }
  };
  const searchHandle = (value) => {
    if (value) {
      const updatedData = allFilter.filter(item => item.value === value)[0];
      const item = updatedData.child
      if (updatedData) {
        let updatedItem = item;
        if (updatedData.parentName === "Fabric Content") {
          updatedItem = {
            ...item,
            min: String(0),
            max: String(100),
            name: `${item.name} (0-100)%`,
            value: `${item.categoryId}(0-100)`
          };
        }
        const hasChildren = _.size(updatedItem.child) > 0;

        setSelectedItems(prevState => {
          const category = updatedData.parentName;
          const existingCategory = prevState.hasOwnProperty(category);

          const isDuplicate = (array, newItem) => {
            return array.some(existingItem => existingItem.categoryId === newItem.categoryId);
          };

          const newItems = hasChildren
            ? updatedItem.child.filter(childItem => !isDuplicate(prevState[category] || [], childItem))
            : [updatedItem].filter(singleItem => !isDuplicate(prevState[category] || [], singleItem));
          return {
            ...prevState,
            [category]: [
              ...(existingCategory ? prevState[category] : []),
              ...newItems
            ]

          }
        });
      }
    }
  }

  const handleSearch = (search) => {
    setSearch(search)
    setHasMore(true)
  }

  const checkboxChange = (event, item) => {
    const isChecked = event.target.checked;
    const hasChildren = _.size(item.child) > 0;

    setSelectedItems(prevState => {
      const category = selectedMenu.name; // Get the current category
      const existingCategory = prevState.hasOwnProperty(category); // Check if category already exists

      // Helper function to check for duplicates based on categoryId
      const isDuplicate = (array, newItem) => {
        return array.some(existingItem => existingItem.categoryId === newItem.categoryId);
      };

      if (isChecked) {
        // If checked, add item and its children to the selected category, avoiding duplicates
        const newItems = hasChildren
          ? item.child.filter(childItem => !isDuplicate(prevState[category] || [], childItem)) // Filter out duplicates
          : [item].filter(singleItem => !isDuplicate(prevState[category] || [], singleItem)); // Add the item itself if not duplicate
        return {
          ...prevState,
          [category]: [
            ...(existingCategory ? prevState[category] : []), // Keep existing items in the category
            ...newItems // Add new non-duplicate items
          ]
        };
      } else {
        // If unchecked, remove item and its children from the selected category
        return {
          ...prevState,
          [category]: existingCategory
            ? prevState[category]?.filter(i =>
              hasChildren
                ? !item.child.some(childItem => childItem.categoryId === i.categoryId) // Remove child items
                : i.categoryId !== item.categoryId // Remove the item itself
            )
            : []
        };
      }
    });
  };
  const checkboxChangeCollection = (event, item) => {
    const isChecked = event.target.checked;
    const hasChildren = _.size(item.pims) > 0;

    setSelectedItems(prevState => {
      const category = selectedMenu.collectionName;
      const existingCategory = prevState.hasOwnProperty(category);

      const isDuplicate = (array, newItem) => {
        return array.some(existingItem => existingItem.collectionId === newItem.collectionId);
      };

      if (isChecked) {
        const newItems = hasChildren
          ? item.pims.filter(childItem => !isDuplicate(prevState[category] || [], childItem))
          : [item].filter(singleItem => !isDuplicate(prevState[category] || [], singleItem));
        return {
          ...prevState,
          [category]: [
            ...(existingCategory ? prevState[category] : []),
            ...newItems
          ]
        };
      } else {
        return {
          ...prevState,
          [category]: existingCategory
            ? prevState[category]?.filter(i =>
              hasChildren
                ? !item.pims.some(childItem => childItem.collectionId === i.collectionId)
                : i.collectionId !== item.collectionId
            )
            : []
        };
      }
    });
  };

  const handleOnApply = (filterHeader, range, item) => {
    const newItem = { ...item };

    if (filterHeader === 'MOQ') {
      setSelectedItems((prevState) => ({
        ...prevState,
        [filterHeader]: [{ moq: String(range), name: `${range} Kg` }],
      }));
    }
    else if (filterHeader === 'Fabric Content') {
      const updatedItem = {
        ...item,
        min: String(range.min),
        max: String(range.max),
        name: `${item.name} (${range.min}-${range.max})%`,
        value: `${item.categoryId}(${range.min}-${range.max})`
      };
      setFilters(prevFilters => ({
        ...prevFilters,
        'Fabric Content': {
          ...prevFilters['Fabric Content'],
          [item.categoryId]: updatedItem
        }
      }));
      setSelectedItems(prevState => {
        const category = selectedMenu.name;
        const existingCategory = prevState.hasOwnProperty(category);

        const updatedItems = existingCategory
          ? prevState[category].filter(content => content.categoryId !== updatedItem.categoryId)
          : [];

        return {
          ...prevState,
          [category]: [...updatedItems, updatedItem],
        };
      });
    }
    else {
      const name = filterHeader === 'Width' ? `${range.min}-${range.max} inch` : filterHeader === 'Weight' ? `${range.min}-${range.max} gsm` : filterHeader === 'Price' ? `₹${range.min} - ₹${range.max}` : '';
      setSelectedItems((prevState) => ({
        ...prevState,
        [filterHeader]: [{ min: String(range.min), max: String(range.max), name: name }],
      }));
    }
  };

  const handleColorClick = (variant) => {
    const category = selectedMenu.name;
    setSelectedItems((prevState) => {
      const existingCategory = prevState.hasOwnProperty(category);
      const isVariantSelected = existingCategory && prevState[category].some(color => color.id === variant.id);
      if (isVariantSelected) {
        return {
          ...prevState,
          [category]: existingCategory ? prevState[category].filter(color => color.id !== variant.id) : []
        };
      } else {
        return {
          ...prevState,
          [category]: existingCategory ? [...prevState[category], variant] : [variant]
        };
      }
    });
  };


  const filterClearAll = () => {
    setSelectedItems(prev => ({ ...prev, [selectedMenu.name]: [] }));
  };

  const overAllFilterClearAll = () => {
    setSelectedItems({ [selectedMenu.name]: [] });
    location.state = '';
    setPage(0);
    setOverAllFilters([]);
  };

  const handleChipClear = (item, isFromOverAll = false) => {
    let category = "";
    if (isFromOverAll) {
      category = item.category;
    } else {
      category = item.category || selectedMenu.name || selectedMenu?.collectionName;
    }
    setSelectedItems(prevState => ({
      ...prevState,
      [category]: prevState[category].filter(i =>
        (category === 'Weight' || category === 'Width' || category === 'Price')
          ? !(i.min === item.min && i.max === item.max)
          : (category === 'Colour' || category === 'Solid / Pattern')
            ? i.variantId !== item.variantId :
            (category === selectedMenu?.collectionName) ? i.pimId !== item.pimId
              : i.categoryId !== item.categoryId
      )
    }));
    setPage(0);
  };

  const handleMenuClick = (menu) => {
    if (menu.name === filterHeader && menuOpened) {
      setMenuOpened(false);
      setFilterHeader('');
      setSelectedMenu({});
      setOverAllMenu({});
      setFilterValues([]);
      return;
    }
    setFilterHeader(menu.collectionName ? "Collection Detail" : menu.name);
    setMenuOpened(true);
    setSelectedMenu(menu);
    setOverAllMenu(menu);
    if (isMobile) {
      setFilterValues(menu);
    } else {
      setFilterValues(menu.filters);
    }
  };

  const handleMenuOutsideClick = () => {
    setMenuOpened(false);
    setFilterHeader('');
  };

  function filteredSearch(searchTerm) {
    function searchAndFilter(item) {
      let result = null;
      if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
        result = { ...item, child: [] };
      }
      item.child?.forEach(child => {
        const filteredChild = searchAndFilter(child);
        if (filteredChild) {
          if (!result) {
            result = { ...item, child: [] };
          }
          result.child.push(filteredChild);
        }
      });
      return result;
    }
    if (!searchTerm) {
      return setSelectedMenu(overAllMenu);
    }
    const menu = selectedMenu?.child?.map(item => searchAndFilter(item)).filter(item => item !== null);
    setSelectedMenu(prev => ({ ...prev, child: menu }));
  }

  const handleSearchClick = (value) => {
    setSideBarFolded(value);
  };

  const getClassName = () => {
    if (isTab) {
      return sideBarFolded ? "view-qualities folded router-view-container" : "view-qualities router-view-container";
    }
    if (isMobile) {
      return "view-qualities folded router-view-container";
    }
    return "view-qualities router-view-container";
  };


  /* Filter Common Codes */
  const [group, setGroup] = useState({});
  const [variants, setVariants] = useState([]);
  const [filters, setFilters] = useState({
    Width: { min: '', max: '' },
    Weight: { min: '', max: '' },
    Price: { min: '', max: '' },
    MOQ: { moq: '' },
    'Fabric Content': {}
  });

  useEffect(() => {
    const keys = Object.keys(selectedItems);
    const newFilters = { ...filters };

    keys.forEach((k) => {
      if (k.includes("Weight") || k.includes("Width") || k.includes("Price")) {
        if (selectedItems[k].length === 0) {
          newFilters[k] = { min: '', max: '' };
        }
      }
      if (k.includes("MOQ") && selectedItems[k].length === 0) {
        newFilters[k] = { moq: '' };
      }
    });

    setFilters(newFilters);
  }, [selectedItems]);

  useEffect(() => {
    if (group) {
      const obj = sortObjectKeysByOrder(group, groupDisplayOrder)
      setGroup(obj)
    }
  }, [groupDisplayOrder])

  useEffect(() => {
    fetchCategoryFilter();
  }, []);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchAllCollections();
    }
  }, []);

  useEffect(() => {
    if (loadColour) {
      fetchVariants()
    }
  }, [loadColour])

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await B2B_API.get('customer/profile').json();
        setProfile(res.response)
      } catch (error) {
      }
    }
    if (localStorage.getItem('token')) {
      fetchProfile();
    }
  }, [B2B_API])

  const getLastTwoLabel = (hierarchyLabel) => {
    const labels = hierarchyLabel.split(' / ');
    return labels.slice(-2).join(' - ');
  }
  const getTopParentAndEachLastInnerChild = (data) => {
    let result = [];

    function findLastInnerChildren(children, parentName) {
      children.forEach(child => {
        if (child.child && child.child.length > 0) {
          findLastInnerChildren(child.child, parentName);
        } else {
          result.push({
            parentName: parentName,
            child: child,
            label: child.hierarchyLabel ? getLastTwoLabel(child.hierarchyLabel) : `${parentName} - ${child.name}`,
            value: child.categoryId
          });
        }
      });
    }

    const topParentName = data.name;

    findLastInnerChildren(data.child, topParentName);

    return result;
  }

  const fetchCategoryFilter = async () => {
    try {
      const res = await B2B_API.get('product-category/filter').json();

      const data = _.sortBy(res.response, 'displayOrder') || [];
      const results = data.flatMap(data => getTopParentAndEachLastInnerChild(data));
      setAllFilter(results);
      const filterKey = new Set(data.map(item => item.group));
      const newGroup = {};
      const groupDisplay = {};
      _.map(data, d => groupDisplay[d.group] = d.groupDisplayOrder)
      setGroupDisplayOrder(prev => ({ ...prev, ...groupDisplay }))
      filterKey.forEach(item => {
        newGroup[item] = _.sortBy(data.filter(val => val.group === item), 'displayOrder');
      });
      newGroup["BASIC"]?.push(
        { name: "Weight", group: "BASIC" },
        { name: "Width", group: "BASIC" },
        { name: "Price", group: "BASIC" },
        { name: "MOQ", group: "BASIC" }
      );
      setGroup(prevGroup => ({
        ...prevGroup,
        ...newGroup,
      }));
      setloadColour(true)
    } catch (error) {
      notify({
        error: true,
        success: false,
        title: error?.message || 'Something went wrong'
      });
    }
  };

  const sortObjectKeysByOrder = (target, displayOrder) => {
    const referenceOrder = Object.fromEntries(
      Object.entries(displayOrder).sort(([, valueA], [, valueB]) => valueA - valueB));
    const sortedKeys = Object.keys(referenceOrder);
    const sortedObj = {};
    sortedKeys.forEach(key => {
      if (target[key]) {
        sortedObj[key] = target[key];
      }
    });
    return sortedObj;
  };

  const fetchAllCollections = async () => {
    try {
      const res = await B2B_API.get('collections/allPublishedWithPims').json();
      const updatedCollections = res?.response?.map(item => ({
        ...item,
        group: "COLLECTIONS"
      })) || [];
      const newGroup = {};
      const filterKey = new Set(updatedCollections.map(item => item.group));
      filterKey.forEach(item => {
        newGroup[item] = _.sortBy(updatedCollections.filter(val => val.group === item), 'displayOrder');
      });
      if (updatedCollections.length > 0) {
        newGroup["COLLECTIONS"] = updatedCollections;
      }
      setGroup(prevGroup => ({
        ...prevGroup,
        ...newGroup,
      }));
      setAllCollection(updatedCollections);
    } catch (error) {
      console.error(error);
    }
  };


  const fetchVariants = async () => {
    try {
      const res = await B2B_API.get('variant/filter').json();
      const data = _.sortBy(res.response, 'displayOrder') || [];
      const filterKey = new Set(data.map(item => item.group));
      const newGroup = {};
      filterKey.forEach(item => {
        newGroup[item] = data.filter(val => val.group === item);
      });
      const groupDisplay = {};
      _.map(data, d => groupDisplay[d.group] = d.groupDisplayOrder)
      setGroupDisplayOrder(prev => ({ ...prev, ...groupDisplay }))
      setGroup(prev => {
        const merged = { ...prev };

        Object.entries(newGroup).forEach(([key, value]) => {
          merged[key] = prev[key] ? [...prev[key], ...value] : value;
        });

        return merged;
      });
      setVariants(data)
      setloadColour(false)
    } catch (err) {
      console.error(err);
    }
  }

  const CheckboxTree = ({ data, handleCheckboxChange, checkedState }) => {
    const handleChange = (itemName, isChecked) => {
      handleCheckboxChange(itemName, isChecked);
    };
    return (
      <>
        {data.map((item, index) => (
          <div key={index} style={{ marginBottom: '0.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input type="checkbox" checked={checkedState[item.name] || false} onChange={(e) => handleChange(item.name, e.target.checked)} id={`checkbox-${item.name}-${index}`} />
              <label htmlFor={`checkbox-${item.name}-${index}`} style={{ marginLeft: '0.5rem' }}>{item.name}</label>
            </div>
            {item.child && (
              <div style={{ marginLeft: '1rem' }}>
                <CheckboxTree data={item.child} handleCheckboxChange={handleCheckboxChange} checkedState={checkedState} />
              </div>
            )}
          </div>
        ))}
      </>
    );
  };

  const handleFilterChange = (filterType, newValue, fabricType) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [filterType]: newValue,
      'Fabric Content': {
        ...prevFilters['Fabric Content'],
        [fabricType]: newValue
      }
    }));
  };



  return (
    <div className={getClassName()}>
      {
        !isMobile && (
          <SideBarLaptop
            group={group}
            variants={variants}
            setFromCollection={setFromCollection}
            sideBarRef={sideBarRef}
            selectedItems={selectedItems}
            selectedMenu={selectedMenu}
            filterHeader={filterHeader}
            checkboxChange={checkboxChange}
            setMenuOpened={setMenuOpened}
            setSelectedItems={(e) => {
              setCollectId(e?.collectionId); setCollectionName(e?.collectionName)
            }}
            collectid={collectid} setCollectId={() => {
              setCollectId(null)

              navigate('/fabrics')
            }}
            filterClearAll={filterClearAll}
            handleChipClear={handleChipClear}
            filteredSearch={filteredSearch}
            handleMenuClick={handleMenuClick}
            handleMenuOutsideClick={handleMenuOutsideClick}
            handleColorClick={handleColorClick}
            handleOnApply={handleOnApply}
            menuOpened={menuOpened}
            allCollection={allCollection}
            toggleMenu={toggleMenu}
            handleFilterChange={handleFilterChange}
            filters={filters}
            allFilter={allFilter}
            searchHandle={searchHandle}
            search={search}
            checkboxChangeCollection={checkboxChangeCollection}
            handlesearch={handleSearch}
          />
        )
      }

      <SideBarMobile
        group={group}
        variants={variants}
        isTab={isTab}
        sideBarFolded={sideBarFolded}
        onSearchClick={handleSearchClick}
        mobileModelOpen={open}
        mobileModelClose={close}
        mobileModelIsOpen={opened}
        selectedMenu={selectedMenu}
        selectedItems={selectedItems}
        chipperArray={overAllFilter}
        fromAppBody={fromCollection}
        ref={mainBodyRef}
        setMenuOpened={setMenuOpened}
        itemCount={itemCount}
        handleChipClear={handleChipClear}
        viewProducts={products}
        loading={loading}
        checkboxChangeCollection={checkboxChangeCollection}
        pimsFromVendorFilter={pims}
        vendorIddApp={vendorIddApp}
        setVendorIddApp={setVendorIddApp}
        hasMore={hasMore}
        overAllFilterClearAll={overAllFilterClearAll}
        setPage={setPage}
        handleMenuClick={handleMenuClick}
        handleMenuOutsideClick={handleMenuOutsideClick}
        checkboxChange={checkboxChange}
        filteredSearch={filteredSearch}
        filterHeader={filterHeader}
        filterClearAll={filterClearAll}
        handleColorClick={handleColorClick}
        fetchProducts={fetchProducts}
        filterValues={filterValues}
        menuOpened={menuOpened}
        toggleMenu={toggleMenu}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleOnApply={handleOnApply}
        sortValue={sortValue}
        setSortValue={setSortValue}
        profile={profile}
        search={search}
        handlesearch={handleSearch}
      />
    </div>
  );
}